// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-container {
  padding: 30px;
  background: #f1ede2;
  min-height: 100vh;
}

/* Filters */
.users-filters {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
  align-items: center;
  background: white;
  padding: 15px 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-group label {
  color: #48546b;
  font-weight: 500;
  white-space: nowrap;
}

.filter-select,
.search-input {
  padding: 8px 12px;
  border: 1px solid #e3ddcd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.filter-select:focus,
.search-input:focus {
  outline: none;
  border-color: #2f6f5e;
  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);
}

.search-input {
  flex: 1 1;
  min-width: 250px;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.spinner {
  animation: spin 1s linear infinite;
  color: #2f6f5e;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container p {
  color: #48546b;
  font-size: 14px;
}

/* Table */
.users-table-wrapper {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 20px;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
}

.users-table thead {
  background: #f1ede2;
  border-bottom: 2px solid #e3ddcd;
}

.users-table th {
  padding: 15px;
  text-align: left;
  font-weight: 600;
  color: #0a1628;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.users-table tbody tr {
  border-bottom: 1px solid #e3ddcd;
  transition: background-color 0.2s ease;
}

.users-table tbody tr:hover {
  background-color: #f1ede2;
}

.users-table td {
  padding: 15px;
  color: #48546b;
  font-size: 14px;
}

.user-name {
  font-weight: 600;
  color: #0a1628;
}

.user-email {
  color: #48546b;
}

.company-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #48546b;
}

.user-joined {
  color: #8792a6;
  font-size: 13px;
}

/* Status Badge */
.status-badge {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-approved {
  background: #e3efe9;
  color: #245349;
}

.status-pending {
  background: #f6ecd9;
  color: #7a5220;
}

.status-rejected {
  background: #fbeae5;
  color: #8a3322;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 8px;
}

.btn-detail,
.btn-block {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-detail {
  background: #e7ecf3;
  color: #132b4d;
}

.btn-detail:hover {
  background: #e7ecf3;
}

.btn-block {
  background: #fbeae5;
  color: #b3432b;
}

.btn-block:hover:not(:disabled) {
  background: #fbeae5;
}

.btn-block:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
}

.pagination-btn {
  padding: 8px 16px;
  background: #2f6f5e;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.pagination-btn:hover:not(:disabled) {
  background: #245349;
  transform: translateY(-2px);
}

.pagination-btn:disabled {
  background: #d8cfb8;
  cursor: not-allowed;
}

.pagination-info {
  color: #48546b;
  font-size: 14px;
}

/* Empty State */
.empty-state {
  background: white;
  border-radius: 8px;
  padding: 60px 20px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.empty-state svg {
  color: #e3ddcd;
  margin-bottom: 15px;
}

.empty-state h3 {
  color: #0a1628;
  font-size: 18px;
  margin: 0 0 5px 0;
  font-weight: 600;
}

.empty-state p {
  color: #8792a6;
  margin: 0;
  font-size: 14px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e3ddcd;
}

.modal-header h2 {
  margin: 0;
  color: #0a1628;
  font-size: 20px;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #8792a6;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #0a1628;
}

.modal-body {
  padding: 20px;
}

.detail-section h3 {
  margin: 0 0 20px 0;
  color: #0a1628;
  font-size: 18px;
}

.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.detail-item.full-width {
  grid-column: 1 / -1;
}

.detail-item label {
  font-size: 12px;
  font-weight: 600;
  color: #8792a6;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 5px;
}

.detail-value {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0a1628;
}

.detail-value a {
  color: #2f6f5e;
  text-decoration: none;
}

.detail-value a:hover {
  text-decoration: underline;
}

.description-text {
  color: #48546b;
  line-height: 1.5;
  margin: 0;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.service-tag {
  display: inline-block;
  background: #e3efe9;
  color: #245349;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
}

.block-section {
  background: #fbeae5;
  padding: 15px;
  border-radius: 6px;
  margin-top: 20px;
  border-left: 4px solid #b3432b;
}

.block-section h4 {
  margin: 0 0 5px 0;
  color: #b3432b;
  font-size: 14px;
}

.block-section p {
  margin: 0 0 10px 0;
  color: #48546b;
  font-size: 13px;
}

.block-textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #fbeae5;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
}

.block-textarea:focus {
  outline: none;
  border-color: #b3432b;
  box-shadow: 0 0 0 3px rgba(179, 67, 43, 0.1);
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid #e3ddcd;
  background: #f1ede2;
}

.btn-cancel {
  padding: 8px 16px;
  background: #f1ede2;
  color: #0a1628;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #e3ddcd;
}

.btn-block-user {
  padding: 8px 16px;
  background: #b3432b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-block-user:hover:not(:disabled) {
  background: #8a3322;
}

.btn-block-user:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Block Confirmation Modal Styles */
.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  background: #fbeae5;
  border: 2px solid #fbeae5;
  border-left: 4px solid #b3432b;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.warning-box h3 {
  margin: 0 0 5px 0;
  color: #b3432b;
  font-size: 16px;
  font-weight: 600;
}

.warning-box p {
  margin: 0;
  color: #48546b;
  font-size: 13px;
  line-height: 1.5;
}

.user-info-section {
  background: #f1ede2;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
}

.user-info-section h4 {
  margin: 0 0 15px 0;
  color: #0a1628;
  font-size: 14px;
  font-weight: 600;
}

.block-reason-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.block-reason-section label {
  font-size: 13px;
  font-weight: 600;
  color: #0a1628;
}

.block-textarea {
  padding: 10px;
  border: 1px solid #e3ddcd;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
}

.block-textarea:focus {
  outline: none;
  border-color: #b3432b;
  box-shadow: 0 0 0 3px rgba(179, 67, 43, 0.1);
}

.btn-confirm-block {
  padding: 8px 16px;
  background: #b3432b;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-confirm-block:hover:not(:disabled) {
  background: #8a3322;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(179, 67, 43, 0.3);
}

.btn-confirm-block:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ================= User Details Modal (creative redesign) ================= */
.user-view-modal {
  max-width: 680px;
  padding: 0;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
}

.uvm-header {
  position: relative;
  background: linear-gradient(135deg, #16463a 0%, #2f6f5e 55%, #3f8a71 100%);
  padding: 28px 28px 24px;
  overflow: hidden;
  flex-shrink: 0;
}

.uvm-header-accent {
  position: absolute;
  top: -50px;
  right: -50px;
  width: 180px;
  height: 180px;
  background: rgba(201, 162, 39, 0.22);
  border-radius: 50%;
}

.uvm-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  z-index: 1;
}

.uvm-close:hover {
  background: rgba(255, 255, 255, 0.28);
}

.uvm-header-content {
  display: flex;
  align-items: center;
  gap: 18px;
  position: relative;
  z-index: 1;
}

.uvm-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(201, 162, 39, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 22px;
  font-weight: 700;
  flex-shrink: 0;
}

.uvm-name {
  margin: 0 0 4px 0;
  color: #fff;
  font-size: 21px;
  font-weight: 700;
}

.uvm-subtitle {
  margin: 0 0 8px 0;
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
}

.uvm-body {
  padding: 22px 26px;
  overflow-y: auto;
  flex: 1 1;
  background: #f7f5ef;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.uvm-card {
  background: white;
  border: 1px solid #e3ddcd;
  border-radius: 10px;
  padding: 18px 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.uvm-card-payment {
  border-left: 4px solid #c9a227;
}

.uvm-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 14px 0;
  font-size: 13px;
  font-weight: 700;
  color: #16463a;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.uvm-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.uvm-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.uvm-field-full {
  grid-column: 1 / -1;
}

.uvm-field label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #8792a6;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.uvm-field span,
.uvm-field a {
  color: #0a1628;
  font-size: 14px;
}

.uvm-field a {
  color: #2f6f5e;
  text-decoration: none;
}

.uvm-field a:hover {
  text-decoration: underline;
}

.uvm-mono {
  font-family: 'Courier New', monospace;
  font-size: 12px !important;
}

.uvm-pay-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  font-size: 13px;
  width: fit-content;
}

.uvm-pay-status.paid {
  color: #245349;
}

.uvm-pay-status.pending {
  color: #7a5220;
}

.uvm-view-invoice-link {
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  padding: 0;
  color: #2f6f5e;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.uvm-view-invoice-link:hover {
  color: #16463a;
}

/* ================= Invoice Viewer Modal ================= */
.invoice-modal {
  background: #1c1c1c;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  /* Sized so one A4 page (1 : 1.414) fills the body below the ~64px header */
  height: 94vh;
  width: calc((94vh - 64px) * 0.7071);
  min-width: 420px;
  max-width: 94vw;
}

.invoice-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 20px;
  background: linear-gradient(135deg, #16463a, #2f6f5e);
  color: white;
  flex-shrink: 0;
}

.invoice-modal-header h3 {
  margin: 0 0 2px 0;
  font-size: 15px;
}

.invoice-modal-header p {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
}

.invoice-modal-actions {
  display: flex;
  gap: 8px;
}

.invoice-download-btn,
.invoice-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.12);
  color: white;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;
  text-decoration: none;
}

.invoice-download-btn:hover,
.invoice-close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
}

.invoice-modal-body {
  flex: 1 1;
  background: #525659;
  display: flex;
  align-items: stretch;
  justify-content: stretch;
  overflow: hidden;
}

.invoice-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

.invoice-modal-status {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: white;
  padding: 40px;
  text-align: center;
}

/* Responsive */
@media (max-width: 768px) {
  .users-container {
    padding: 20px;
  }

  .users-filters {
    flex-direction: column;
    gap: 10px;
  }

  .filter-group {
    width: 100%;
  }

  .search-input {
    width: 100%;
  }

  .detail-grid,
  .uvm-grid {
    grid-template-columns: 1fr;
  }

  .uvm-header-content {
    gap: 12px;
  }

  .uvm-avatar {
    width: 52px;
    height: 52px;
    font-size: 18px;
  }

  .invoice-modal {
    width: 100%;
    min-width: 0;
    height: 85vh;
  }

  .users-table {
    font-size: 12px;
  }

  .users-table th,
  .users-table td {
    padding: 10px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-detail,
  .btn-block {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/Users.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,2EAA2E;EAC3E,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,qDAAqD;EACrD,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":[".users-container {\n  padding: 30px;\n  background: #f1ede2;\n  min-height: 100vh;\n}\n\n/* Filters */\n.users-filters {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 25px;\n  align-items: center;\n  background: white;\n  padding: 15px 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-group label {\n  color: #48546b;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.filter-select,\n.search-input {\n  padding: 8px 12px;\n  border: 1px solid #e3ddcd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.filter-select:focus,\n.search-input:focus {\n  outline: none;\n  border-color: #2f6f5e;\n  box-shadow: 0 0 0 3px rgba(47, 111, 94, 0.1);\n}\n\n.search-input {\n  flex: 1;\n  min-width: 250px;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.spinner {\n  animation: spin 1s linear infinite;\n  color: #2f6f5e;\n  margin-bottom: 15px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container p {\n  color: #48546b;\n  font-size: 14px;\n}\n\n/* Table */\n.users-table-wrapper {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.users-table thead {\n  background: #f1ede2;\n  border-bottom: 2px solid #e3ddcd;\n}\n\n.users-table th {\n  padding: 15px;\n  text-align: left;\n  font-weight: 600;\n  color: #0a1628;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.users-table tbody tr {\n  border-bottom: 1px solid #e3ddcd;\n  transition: background-color 0.2s ease;\n}\n\n.users-table tbody tr:hover {\n  background-color: #f1ede2;\n}\n\n.users-table td {\n  padding: 15px;\n  color: #48546b;\n  font-size: 14px;\n}\n\n.user-name {\n  font-weight: 600;\n  color: #0a1628;\n}\n\n.user-email {\n  color: #48546b;\n}\n\n.company-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #48546b;\n}\n\n.user-joined {\n  color: #8792a6;\n  font-size: 13px;\n}\n\n/* Status Badge */\n.status-badge {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-approved {\n  background: #e3efe9;\n  color: #245349;\n}\n\n.status-pending {\n  background: #f6ecd9;\n  color: #7a5220;\n}\n\n.status-rejected {\n  background: #fbeae5;\n  color: #8a3322;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-detail,\n.btn-block {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-detail {\n  background: #e7ecf3;\n  color: #132b4d;\n}\n\n.btn-detail:hover {\n  background: #e7ecf3;\n}\n\n.btn-block {\n  background: #fbeae5;\n  color: #b3432b;\n}\n\n.btn-block:hover:not(:disabled) {\n  background: #fbeae5;\n}\n\n.btn-block:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.pagination-btn {\n  padding: 8px 16px;\n  background: #2f6f5e;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.pagination-btn:hover:not(:disabled) {\n  background: #245349;\n  transform: translateY(-2px);\n}\n\n.pagination-btn:disabled {\n  background: #d8cfb8;\n  cursor: not-allowed;\n}\n\n.pagination-info {\n  color: #48546b;\n  font-size: 14px;\n}\n\n/* Empty State */\n.empty-state {\n  background: white;\n  border-radius: 8px;\n  padding: 60px 20px;\n  text-align: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.empty-state svg {\n  color: #e3ddcd;\n  margin-bottom: 15px;\n}\n\n.empty-state h3 {\n  color: #0a1628;\n  font-size: 18px;\n  margin: 0 0 5px 0;\n  font-weight: 600;\n}\n\n.empty-state p {\n  color: #8792a6;\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #e3ddcd;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #0a1628;\n  font-size: 20px;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #8792a6;\n  cursor: pointer;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-close:hover {\n  color: #0a1628;\n}\n\n.modal-body {\n  padding: 20px;\n}\n\n.detail-section h3 {\n  margin: 0 0 20px 0;\n  color: #0a1628;\n  font-size: 18px;\n}\n\n.detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.detail-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.detail-item label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #8792a6;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 5px;\n}\n\n.detail-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #0a1628;\n}\n\n.detail-value a {\n  color: #2f6f5e;\n  text-decoration: none;\n}\n\n.detail-value a:hover {\n  text-decoration: underline;\n}\n\n.description-text {\n  color: #48546b;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.service-tag {\n  display: inline-block;\n  background: #e3efe9;\n  color: #245349;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.block-section {\n  background: #fbeae5;\n  padding: 15px;\n  border-radius: 6px;\n  margin-top: 20px;\n  border-left: 4px solid #b3432b;\n}\n\n.block-section h4 {\n  margin: 0 0 5px 0;\n  color: #b3432b;\n  font-size: 14px;\n}\n\n.block-section p {\n  margin: 0 0 10px 0;\n  color: #48546b;\n  font-size: 13px;\n}\n\n.block-textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #fbeae5;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.block-textarea:focus {\n  outline: none;\n  border-color: #b3432b;\n  box-shadow: 0 0 0 3px rgba(179, 67, 43, 0.1);\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 15px 20px;\n  border-top: 1px solid #e3ddcd;\n  background: #f1ede2;\n}\n\n.btn-cancel {\n  padding: 8px 16px;\n  background: #f1ede2;\n  color: #0a1628;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.btn-cancel:hover {\n  background: #e3ddcd;\n}\n\n.btn-block-user {\n  padding: 8px 16px;\n  background: #b3432b;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.btn-block-user:hover:not(:disabled) {\n  background: #8a3322;\n}\n\n.btn-block-user:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Block Confirmation Modal Styles */\n.warning-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  background: #fbeae5;\n  border: 2px solid #fbeae5;\n  border-left: 4px solid #b3432b;\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n}\n\n.warning-box h3 {\n  margin: 0 0 5px 0;\n  color: #b3432b;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.warning-box p {\n  margin: 0;\n  color: #48546b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.user-info-section {\n  background: #f1ede2;\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n}\n\n.user-info-section h4 {\n  margin: 0 0 15px 0;\n  color: #0a1628;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.block-reason-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.block-reason-section label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0a1628;\n}\n\n.block-textarea {\n  padding: 10px;\n  border: 1px solid #e3ddcd;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.block-textarea:focus {\n  outline: none;\n  border-color: #b3432b;\n  box-shadow: 0 0 0 3px rgba(179, 67, 43, 0.1);\n}\n\n.btn-confirm-block {\n  padding: 8px 16px;\n  background: #b3432b;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.btn-confirm-block:hover:not(:disabled) {\n  background: #8a3322;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(179, 67, 43, 0.3);\n}\n\n.btn-confirm-block:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ================= User Details Modal (creative redesign) ================= */\n.user-view-modal {\n  max-width: 680px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  max-height: 90vh;\n  overflow: hidden;\n}\n\n.uvm-header {\n  position: relative;\n  background: linear-gradient(135deg, #16463a 0%, #2f6f5e 55%, #3f8a71 100%);\n  padding: 28px 28px 24px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.uvm-header-accent {\n  position: absolute;\n  top: -50px;\n  right: -50px;\n  width: 180px;\n  height: 180px;\n  background: rgba(201, 162, 39, 0.22);\n  border-radius: 50%;\n}\n\n.uvm-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: rgba(255, 255, 255, 0.15);\n  border: none;\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  z-index: 1;\n}\n\n.uvm-close:hover {\n  background: rgba(255, 255, 255, 0.28);\n}\n\n.uvm-header-content {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  position: relative;\n  z-index: 1;\n}\n\n.uvm-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n  border: 2px solid rgba(201, 162, 39, 0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 22px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.uvm-name {\n  margin: 0 0 4px 0;\n  color: #fff;\n  font-size: 21px;\n  font-weight: 700;\n}\n\n.uvm-subtitle {\n  margin: 0 0 8px 0;\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 13px;\n}\n\n.uvm-body {\n  padding: 22px 26px;\n  overflow-y: auto;\n  flex: 1;\n  background: #f7f5ef;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.uvm-card {\n  background: white;\n  border: 1px solid #e3ddcd;\n  border-radius: 10px;\n  padding: 18px 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.uvm-card-payment {\n  border-left: 4px solid #c9a227;\n}\n\n.uvm-card-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 14px 0;\n  font-size: 13px;\n  font-weight: 700;\n  color: #16463a;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.uvm-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.uvm-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.uvm-field-full {\n  grid-column: 1 / -1;\n}\n\n.uvm-field label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #8792a6;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.uvm-field span,\n.uvm-field a {\n  color: #0a1628;\n  font-size: 14px;\n}\n\n.uvm-field a {\n  color: #2f6f5e;\n  text-decoration: none;\n}\n\n.uvm-field a:hover {\n  text-decoration: underline;\n}\n\n.uvm-mono {\n  font-family: 'Courier New', monospace;\n  font-size: 12px !important;\n}\n\n.uvm-pay-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 700;\n  font-size: 13px;\n  width: fit-content;\n}\n\n.uvm-pay-status.paid {\n  color: #245349;\n}\n\n.uvm-pay-status.pending {\n  color: #7a5220;\n}\n\n.uvm-view-invoice-link {\n  margin-top: 16px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: none;\n  border: none;\n  padding: 0;\n  color: #2f6f5e;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.uvm-view-invoice-link:hover {\n  color: #16463a;\n}\n\n/* ================= Invoice Viewer Modal ================= */\n.invoice-modal {\n  background: #1c1c1c;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);\n  display: flex;\n  flex-direction: column;\n  /* Sized so one A4 page (1 : 1.414) fills the body below the ~64px header */\n  height: 94vh;\n  width: calc((94vh - 64px) * 0.7071);\n  min-width: 420px;\n  max-width: 94vw;\n}\n\n.invoice-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #16463a, #2f6f5e);\n  color: white;\n  flex-shrink: 0;\n}\n\n.invoice-modal-header h3 {\n  margin: 0 0 2px 0;\n  font-size: 15px;\n}\n\n.invoice-modal-header p {\n  margin: 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.invoice-modal-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.invoice-download-btn,\n.invoice-close-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.12);\n  color: white;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  text-decoration: none;\n}\n\n.invoice-download-btn:hover,\n.invoice-close-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n.invoice-modal-body {\n  flex: 1;\n  background: #525659;\n  display: flex;\n  align-items: stretch;\n  justify-content: stretch;\n  overflow: hidden;\n}\n\n.invoice-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  background: white;\n}\n\n.invoice-modal-status {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  color: white;\n  padding: 40px;\n  text-align: center;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .users-container {\n    padding: 20px;\n  }\n\n  .users-filters {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .filter-group {\n    width: 100%;\n  }\n\n  .search-input {\n    width: 100%;\n  }\n\n  .detail-grid,\n  .uvm-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .uvm-header-content {\n    gap: 12px;\n  }\n\n  .uvm-avatar {\n    width: 52px;\n    height: 52px;\n    font-size: 18px;\n  }\n\n  .invoice-modal {\n    width: 100%;\n    min-width: 0;\n    height: 85vh;\n  }\n\n  .users-table {\n    font-size: 12px;\n  }\n\n  .users-table th,\n  .users-table td {\n    padding: 10px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n  }\n\n  .btn-detail,\n  .btn-block {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
